import { isObject } from "@pineapplelab/util";
import { FBase } from "./FBase";
import { CreditCardType } from "../enums/creditCardType.enum";
import { CreditCardUtils } from "../utils/creditCardUtils";

export class PaymentMethod extends FBase {

	userId: string = null;
	token: string = null;
	lastFour: string = null;
	cardType: CreditCardType = null;
	expirationDate: string = null;
	orderId: string = null;

	__isNew: boolean = false;
	__cardTypeEnum: CreditCardType = null;
	__creditCardData: any = {};
	__billingDetails: any = {};

	constructor(json?: { [key: string]: any }) {
		super();
		if (isObject(json)) {
			this.fromJson(json);
			this.__cardTypeEnum = this.resolveCreditCardType(this.cardType);
		}
	}

	private resolveCreditCardType(cardType: string | number): CreditCardType {
		if (typeof cardType === 'string') {
			return CreditCardUtils.getCreditCardByName(cardType);
		}
		if (CreditCardType[cardType]) {
			return cardType;
		}
		return null;
	}

}
export namespace PaymentMethod {

	export const PATH = 'paymentMethods';

}
